import { createFileRoute } from '@tanstack/react-router';
import WebDesignedAccountPage from '../../components/webdesigned/WebDesignedAccountPage';
import WebDesignedPortal from '../../components/portals/WebDesignedPortal';

export const Route = createFileRoute('/webdesigned/account')({
  component: () => (
    <WebDesignedPortal>
      <WebDesignedAccountPage />
    </WebDesignedPortal>
  ),
});
